import React from "react";
import {
  SkeletonBlock,
  SkeletonText,
  SkeletonRows,
  SkeletonImage,
} from "component/Loading";

export const MaterialCardSkeleton = () => (
  <div className="material-card skeleton-card">
    <div className="material-header">
      <SkeletonBlock width="45%" height={16} />
      <SkeletonBlock width="35%" height={14} />
    </div>
    <div className="material-chart-wrapper" style={{ minHeight: "120px" }}>
      <SkeletonImage height="120px" radius={10} />
    </div>
    <div className="material-footer">
      <SkeletonBlock width="70%" height={16} />
      <SkeletonBlock width="55%" height={12} style={{ marginTop: 8 }} />
    </div>
  </div>
);

export const SectorCardSkeleton = () => (
  <div className="sector-card skeleton-card">
    <SkeletonImage height="180px" radius={12} />
    <SkeletonBlock width="60%" height={14} style={{ marginTop: 12 }} />
  </div>
);

export const CompareItemSkeleton = () => (
  <div className="compare-dropdown-item">
    <div className="d-flex flex-column gap-2 w-100">
      <SkeletonBlock width="70%" height={14} />
      <SkeletonBlock width="55%" height={12} />
    </div>
  </div>
);

export const MaterialsTableSkeleton = ({ rows = 4, columns = 5 }) => (
  <div className="skeleton-card p-3">
    <SkeletonRows rows={rows} columns={columns} />
  </div>
);

const ChartSkeletons = {
  MaterialCardSkeleton,
  SectorCardSkeleton,
  CompareItemSkeleton,
  MaterialsTableSkeleton,
};

export default ChartSkeletons;
